// customEase.js
import { gsap, CustomEase } from 'gsap/all'

// CustomEaseを登録して作成
gsap.registerPlugin(CustomEase)
CustomEase.create('primary-ease', '0.62, 0.05, 0.01, 0.99')

export const primaryEase = 'primary-ease'
